/* Layout */
import Layout from '@/views/layout/Layout';
import WarningInfo from '@/views/warningInfo/index';

const warningInfoRouter = {
  path: '/manage/warning',
  name: 'warning',
  props: true,
  meta: {
    icon: 'warning',
    requiresAuth: true,
    role: 'user',
    title: '预警信息',
    perms: ['WarningNotify.List']
  },
  hidden: false,
  component: Layout,
  children: [
    {
      path: 'info',
      name: 'warningAlls',
      component: WarningInfo,
      meta: {
        title: '预警信息',
        icon: 'warning',
        requiresAuth: true,
        perms: ['WarningNotify.List']
      }
    }
  ]
};
export default warningInfoRouter



// WEBPACK FOOTER //
// ./src/router/modules/warningInfo.js